import React from 'react';

import logo from 'images/nifty-logo.svg';

import './PoweredBy.styles.scss';

const PoweredBy = () => (
    <a href="https://niftypm.com" target="_blank" className="powered-by">
        Powered by <img src={logo} width={64} />
    </a>
)

export default PoweredBy;
